import { render } from "./Mensaje.vue?vue&type=template&id=592107d2"
import script from "./Mensaje.vue?vue&type=script&lang=js"
export * from "./Mensaje.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__